var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 2.8c0-.11.09-.2.2-.2h7.4c.11 0 .2.09.2.2v7.4a.2.2 0 01-.2.2h-.6V4.8a1.4 1.4 0 00-1.4-1.4H5.6v-.6zm-1.2.6v-.6a1.4 1.4 0 011.4-1.4h7.4a1.4 1.4 0 011.4 1.4v7.4a1.4 1.4 0 01-1.4 1.4h-.6v1.6a1.4 1.4 0 01-1.4 1.4H2.8a1.4 1.4 0 01-1.4-1.4V4.8a1.4 1.4 0 011.4-1.4h1.6zM2.6 4.8c0-.11.09-.2.2-.2h8.4c.11 0 .2.09.2.2v8.4a.2.2 0 01-.2.2H2.8a.2.2 0 01-.2-.2V4.8z",
    fill: "#A8AAAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5h5M4.5 10.5h5",
    stroke: "#A8AAAD",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/copy.b4939052.svg";
export { SvgCopy as ReactComponent };